import {
  dateOperating
} from '@/cllib/tools'

import {
  distributionGetData
} from '@/api/api'

let statusTextMap = {
  way: '在途',
  plan: '计划',
  end: '入库'
}

const state = {
  relatedDistribution: [],
  relatedDistributionLoading: false,
  updateRelatedDistribution: {},
  updateRelatedDistributionIng: false
}

const getters = {
  relatedDistribution: state => state.relatedDistribution,
  relatedDistributionLoading: state => state.relatedDistributionLoading,
  updateRelatedDistribution: state => state.updateRelatedDistribution,
  updateRelatedDistributionIng: state => state.updateRelatedDistributionIng
}

const actions = {
  loadRelatedDistribution ({ dispatch, getters }) {
    dispatch('setUpdateRelatedDistribution', {})
    if (!getters.chooseErrorInvoicing.id) {
      dispatch('setRelatedDistribution', [])
      return
    }
    dispatch('setRelatedDistributionLoading', true)
    let chooseErrorInvoicingCollectTime = getters.chooseErrorInvoicingCollectTime
    let parm = {
      noPage: 1,
      gasTankId: getters.chooseErrorInvoicing.gasTankId,
      planTime: dateOperating.computeDay({days: -10, date: chooseErrorInvoicingCollectTime, format: 'yy-mm-dd'}),
      endTime: dateOperating.computeDay({days: 5, date: chooseErrorInvoicingCollectTime, format: 'yy-mm-dd'})
    }
    distributionGetData(parm).then((data) => {
      data.forEach((item) => {
        item.isDel = item.isDel ? 1 : 0
        item.planTime = item.planTime.slice(5, 10)
        item.planVolume = parseInt(item.planVolume)
        item.sendTime = item.sendTime ? item.sendTime.slice(5, 16) : '--'
        item.inTimeS = item.inTime ? item.inTime.slice(5, 16) : '--'
        item.statusText = statusTextMap[item.status]
        item.oilNameS = item.oilName.split('号')[0] + '#'
        item.gasTankId = item.mergeId || item.gasTankId
        item.tankMark = item.mergeTankMark ? (item.tankMark + '/' + item.mergeTankMark) : item.tankMark
      })
      dispatch('setRelatedDistribution', data)
      dispatch('setRelatedDistributionLoading', false)
    }).catch((e) => {
      dispatch('setRelatedDistributionLoading', false)
    })
  },
  updateRelatedDistributionOne ({ commit, dispatch, getters }, data) {
    if (getters.updateRelatedDistributionIng) {
      return
    }
    commit('setUpdateRelatedDistributionIng', true)
    let changeData = {
      new: {},
      his: {}
    }
    getters.relatedDistribution.forEach((item) => {
      if (item.id === data.id) {
        changeData.his = {
          inTime: item.inTime,
          inVolume: item.inVolume,
          gasTankId: item.gasTankId,
          isDel: item.isDel
        }
      }
    })
    commit('updateRelatedDistributionOne', data)
    getters.relatedDistribution.forEach((item) => {
      if (item.id === data.id) {
        changeData.new = {
          inTime: item.inTime,
          inVolume: item.inVolume,
          gasTankId: item.gasTankId,
          isDel: item.isDel
        }
      }
    })
    dispatch('updateRelatedInvoicingOne', changeData)
    dispatch('setUpdateRelatedDistributionIng', false)
  },
  setRelatedDistribution ({ commit }, data) {
    commit('setRelatedDistribution', data)
  },
  setUpdateRelatedDistributionIng ({ commit }, data) {
    commit('setUpdateRelatedDistributionIng', data)
  },
  setRelatedDistributionLoading ({ commit }, data) {
    commit('setRelatedDistributionLoading', data)
  },
  setUpdateRelatedDistribution ({ commit }, data) {
    commit('setUpdateRelatedDistribution', data)
  }
}

const mutations = {
  setUpdateRelatedDistributionIng (state, data) {
    state.updateRelatedDistributionIng = data
  },
  setRelatedDistribution (state, data) {
    state.relatedDistribution = data
  },
  setRelatedDistributionLoading (state, data) {
    state.relatedDistributionLoading = data
  },
  setUpdateRelatedDistribution (state, data) {
    state.updateRelatedDistribution = data
  },
  updateRelatedDistributionOne (state, data) {
    state.relatedDistribution.forEach((item) => {
      if (item.id === data.id) {
        if (data.inTime) {
          item.inTime = dateOperating.formatDate({date: data.inTime, format: 'yy-mm-dd hh:mm:ss'})
          item.inTimeS = item.inTime ? item.inTime.slice(5, 16) : '--'
          item.loadVolume = item.loadVolume === null ? item.planVolume : item.loadVolume
          item.inVolume = item.inVolume === null ? item.loadVolume : item.inVolume
          item.status = 'end'
          item.statusText = statusTextMap[item.status]
        }
        if (typeof data.isDel !== 'undefined') {
          item.isDel = data.isDel
        }
        state.updateRelatedDistribution['key_' + item.id] = {
          id: item.id,
          transferType: item.transferType,
          isDel: item.isDel,
          transferNo: item.transferNo,
          status: item.status,
          inVolume: item.inVolume,
          inTime: item.inTime,
          loadVolume: item.loadVolume,
          replaceUpdate: 0,
          erpId: item.erpId
        }
      }
    })
    let asd = {}
    for (let key in state.updateRelatedDistribution) {
      asd[key] = state.updateRelatedDistribution[key]
    }
    state.updateRelatedDistribution = asd
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/invoicing_check/related_distribution.js